/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-09-26 09:42:45
 * @LastEditors: Jianyong Wang
 * @LastEditTime: 2021-11-04 18:15:37
 */
export enum RoleEnum {
  NO_PERMISSION = 0,
  READ_ONLY = 1,
  OPERATE = 2,
  OPERATE_READ = 3
}
